export default __webpack_public_path__ + "static/media/delete_icon.0dc86644.svg";